module.exports = __webpack_public_path__ + "components/country-flag/static/gm-7d52c242ba3554cf7962819ab3784731.svg";